import React from 'react';

import HeaderSearchForm from './HeaderSearchForm';
import MobileNavigationBrand from './MobileNavigationBrand';


type MobileNavigationHeaderProps = {
  closeMobileMenu?: () => void;
};

const MobileNavigationHeader: React.FC<MobileNavigationHeaderProps> = ({
  closeMobileMenu,
}) => {
  return (
    <div className="mobile-navigation-header">
      <div className="mobile-navigation-header__brand">
        <MobileNavigationBrand onNavigate={closeMobileMenu} />
      </div>

      <HeaderSearchForm
        inputId="mobile-navigation-search-input"
        className="mobile-navigation-search"
        onEscape={closeMobileMenu}
        onSubmit={closeMobileMenu}
      />
    </div>
  );
};

export default MobileNavigationHeader;
